import VisibilityContent from '../components/VisibilityContent'
import { schedulerActions } from '../../../modules/Instrument'
import { connect } from 'react-redux'
import { hasMultiScheduleFeature } from 'utils/studyConfigUtils'
import {
  resolveScheduleVisibility,
  usesPerScheduleVisibility,
} from 'routes/Studies/routes/Study/routes/Instruments/utils/scheduleVisibility'

const mapStateToProps = ({ instrumentReducer, study }, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const { instrument, confirmedSchedules, activeScheduleIndex } = instrumentReducer
  const metadata = instrument?.metadata || {}
  const hasMultiSchedule = hasMultiScheduleFeature(study?.currentStudy)
  const usePerScheduleVisibility = usesPerScheduleVisibility(hasMultiSchedule)
  const scheduleVisibility = usePerScheduleVisibility
    ? resolveScheduleVisibility(metadata.schedule, metadata)
    : resolveScheduleVisibility(null, metadata)

  return {
    ...metadata.schedule,
    metadata,
    studyVersionID,
    usePerScheduleVisibility,
    visibility: scheduleVisibility.visibility,
    visibilityRanges: scheduleVisibility.visibilityRanges,
  }
}

export default connect(mapStateToProps, schedulerActions)(VisibilityContent)
